/**
 * Background
 */
// export const THEME_COLOR = 'hsl(2, 84%, 64%)';
// export const THEME_COLOR_SB = 'hsl(182,38%,58%)';
// export const THEME_COLOR_LB = 'hsl(205, 49%, 52%)';
// export const THEME_COLOR = 'hsl(2, 64%, 57%)';
// export const THEME_COLOR = 'hsl(2, 66%, 58%)';
// export const THEME_COLOR = 'rgb(186, 73, 73)';
export const THEME_COLOR = 'rgb(163 71 71)';
// export const THEME_COLOR_SB = 'hsl(182,35%,42%)';
export const THEME_COLOR_SB = 'rgb(44 126 132)';
// export const THEME_COLOR_LB = 'hsl(205, 43%, 46%)';
// export const THEME_COLOR_LB = 'hsl(205, 43%, 46%)';
export const THEME_COLOR_LB = 'rgb(47 106 149)';
/**
 * Them Colors
 */
// // export const THEME_POMODORO = 'rgb(217 85 80)';
// export const THEME_POMODORO = 'rgb(186, 73, 73)';
// export const THEME_GREEN = 'rgb(56 133 138)';
// export const THEME_BLUE = 'rgb(57 112 151)';
// // export const THEME_BROWN = 'rgb(155, 130, 56)';
// export const THEME_BROWN = 'rgb(171 101 43)';
// export const THEME_VIOLET = 'rgb(125 83 162)';
// export const THEME_PINK = '#af4e91';
// export const THEME_FOREST_GREEN = 'rgb(81 138 88)';
// export const THEME_DARK_GRAY = '#545764';
// export const THEME_COLOR_OPTIONS = [
//   THEME_POMODORO,
//   THEME_GREEN,
//   THEME_BLUE,
//   THEME_BROWN,
//   THEME_VIOLET,
//   THEME_PINK,
//   THEME_FOREST_GREEN,
//   THEME_DARK_GRAY,
// ];
// export const THEME_COLOR = 'hsla(181, 71%, 40%, 1.000)';
export const BG_GRAY = 'hsla(357,10%,68%,.2)';
export const THEME_COLOR_DARK = 'hsl(357,77%,60%)';
export const THEME_COLOR_DARKER = 'hsl(357,68%,50%)';
export const DARK_WHITE = '#aaa';
export const POSITIVE_COLOR = 'yellowgreen';
export const NEGATIVE_COLOR = 'hsl(368, 84%, 53%)';
/**
 * Font
 */
export const BLACK_0 = 'hsl(357, 0%, 4%)';
export const BLACK_1 = 'hsl(357, 0%, 14%)';
export const BLACK_2 = 'hsl(357, 0%, 24%)';
export const BLACK_3 = 'hsl(357, 0%, 34%)';
export const BLACK_4 = 'hsl(357, 0%, 44%)';
export const BLACK_5 = 'hsl(357, 0%, 54%)';
export const BLACK_6 = 'hsl(357, 0%, 64%)';
export const BLACK_7 = 'hsl(357, 0%, 74%)';
export const BLACK_8 = 'hsl(357, 0%, 84%)';
export const BLACK_9 = 'hsl(357, 0%, 94%)';
export const TINT_BLACK_0 = 'hsl(357, 49%, 4%)';
export const TINT_BLACK_1 = 'hsl(357, 39%, 14%)';
export const TINT_BLACK_2 = 'hsl(357, 29%, 24%)';
export const TINT_BLACK_3 = 'hsl(357, 19%, 34%)';
export const TINT_BLACK_4 = 'hsl(357, 9%, 44%)';
export const TINT_BLACK_5 = 'hsl(357, 9%, 54%)';
export const TINT_BLACK_6 = 'hsl(357, 9%, 64%)';
export const TINT_BLACK_7 = 'hsl(357, 9%, 74%)';
export const TINT_BLACK_8 = 'hsl(357, 9%, 84%)';
export const TINT_BLACK_9 = 'hsl(357, 9%, 94%)';
export const THEME_COLOR_0 = 'hsl(2, 54%, 4%)';
export const THEME_COLOR_1 = 'hsl(2, 54%, 14%)';
export const THEME_COLOR_2 = 'hsl(2, 54%, 24%)';
export const THEME_COLOR_3 = 'hsl(2, 54%, 34%)';
export const THEME_COLOR_4 = 'hsl(2, 54%, 44%)';
export const THEME_COLOR_5 = 'hsl(2, 54%, 54%)';
export const THEME_COLOR_6 = 'hsl(2, 54%, 64%)';
export const THEME_COLOR_7 = 'hsl(2, 54%, 74%)';
export const THEME_COLOR_8 = 'hsl(2, 54%, 84%)';
export const THEME_COLOR_9 = 'hsl(2, 54%, 94%)';
/**
 * Font
 */
// export const FONT_PRIMARY = '#222';
export const FONT_PRIMARY = '#222';
export const FONT_SECONDARY = '#555';
export const FONT_THIRD = '#aaa';
export const FONT_RED = 'hsl(357deg 63% 68%)';
/**
 * Button
 */
export const BTN_PRIMARY = 'hsla(181, 71%, 40%, 1.000)';
export const BTN_DISABLED = '#999';
